import { Navigate, useLocation } from "react-router-dom";

// Anciennes URL (site IONOS / anciennes routes) -> nouvelles pages
export const REDIRECTS = {
  "/presentation": "/a-propos",
  "/formules": "/tarifs-conciergerie-brest/",
  "/services": "/prestations",
  "/politique-de-confidentialite": "/confidentialite",
  "/boutique": "/tarifs-conciergerie-brest/",
  "/boutique/visite-et-controle-c204926175": "/surveillance-maison-brest/",
  "/boutique/visite-de-controle-simple-p856804672": "/surveillance-maison-brest/",
  "/boutique/aeration-controle-des-interieur-p856825024": "/surveillance-maison-brest/",
  "/boutique/diagnostic-visuel-du-logement-p856804695": "/surveillance-maison-brest/",
  "/boutique/relever-de-compteur-exterieur-p856812381": "/surveillance-maison-brest/",
  "/boutique/releve-remise-du-courrier-p856825042": "/surveillance-maison-brest/",
  "/boutique/preparation-du-logement-avant-arriver-p856804673": "/remise-cles-brest/",
  "/boutique/fermeture-du-logement-apres-depart-p856804691": "/remise-cles-brest/",
  "/boutique/menage-&-prestation-c204925940": "/entretien-logement-brest/",
  "/boutique/menage-studio-T1-p856804692": "/entretien-logement-brest/",
  "/boutique/menage-T2-p856812393": "/entretien-logement-brest/",
  "/boutique/menage-T3-p856804693": "/entretien-logement-brest/",
  "/boutique/menage-T4-p856825044": "/entretien-logement-brest/",
  "/boutique/nettoyage-des-vitres-p856825045": "/entretien-logement-brest/",
  "/boutique/nettoyage-terrasse-exterieur-p856825046": "/entretien-logement-brest/",
  "/boutique/gestion-du-linge-p856812395": "/entretien-logement-brest/",
  "/boutique/maintenance-&-petits-travaux-c204926177": "/petits-travaux-brest/",
  "/boutique/petite-reparation-p856812396": "/petits-travaux-brest/",
  "/boutique/montage-de-meuble-p856812397": "/petits-travaux-brest/",
  "/boutique/petite-plomberie-p856812398": "/petits-travaux-brest/",
  "/boutique/petite-electricite-p856812399": "/petits-travaux-brest/",
  "/boutique/peinture-retouche-p856812400": "/petits-travaux-brest/",
  "/boutique/entretien-exterieur-p856812401": "/petits-travaux-brest/",
  "/boutique/coordination-dun-artisan-p856812403": "/petits-travaux-brest/",
  "/boutique/intervention-depannage-p856804694": "/petits-travaux-brest/",
  "/boutique/intervention-URGENTE-p856825043": "/petits-travaux-brest/",
};

const norm = (p) => decodeURIComponent(p).replace(/\/+$/, "") || "/";

export const redirectTarget = (pathname) => {
  const p = norm(pathname);
  if (REDIRECTS[p]) return REDIRECTS[p];
  return p.startsWith("/boutique/") ? "/tarifs-conciergerie-brest/" : null;
};

export const RedirectOr = ({ children }) => {
  const { pathname } = useLocation();
  const to = redirectTarget(pathname);
  return to ? <Navigate to={to} replace /> : children;
};
